import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AchDebit } from '../../../settings-data/sub-models/company-settings/ach-debit.model';
import { MoneyPipe } from '../../../shared/pipes/money/money.pipe';
import { TranslateService } from '@ngx-translate/core';
import { PercentagePipe } from '../../../shared/pipes/percentage/percentage.pipe';
import { List } from 'immutable';

@Injectable()
export class PaymentOptionsBuilder {
  FORM_KEYS = {
    BANK_TRANSFER_ENABLED: 'bankTransferEnabled',
    CARD_PAYMENTS_ENABLED: 'cardPaymentsEnabled',
    PAYPAL_EC_ENABLED: 'paypalEcEnabled',
    I2G_MONEY_ENABLED: 'i2gMoneyEnabled',
  };

  constructor(
    private _formBuilder: FormBuilder,
    private _percentagePipe: PercentagePipe,
    private _moneyPipe: MoneyPipe,
    private _translateService: TranslateService
  ) {}

  buildForm(
    bankTransferEnabled: boolean,
    cardPaymentsEnabled: boolean,
    paypalEcEnabled: boolean,
    i2gMoneyEnabled: boolean
  ): FormGroup {
    return this._formBuilder.group({
      [this.FORM_KEYS.BANK_TRANSFER_ENABLED]: [bankTransferEnabled],
      [this.FORM_KEYS.CARD_PAYMENTS_ENABLED]: [cardPaymentsEnabled],
      [this.FORM_KEYS.PAYPAL_EC_ENABLED]: [paypalEcEnabled],
      [this.FORM_KEYS.I2G_MONEY_ENABLED]: [i2gMoneyEnabled],
    });
  }

  buildBankTransferDescription(achDebit: AchDebit, locale: string): string {
    const currencyCode = achDebit.currencyCode;
    const translateParams = {
      feesPercentage: this._percentagePipe.transform(
        achDebit.feesPercentage,
        locale
      ),
      feesMaximum: this._moneyPipe.transform(
        achDebit.feesMaximum,
        currencyCode,
        locale
      ),
      feesMinimum: this._moneyPipe.transform(
        achDebit.feesMinimum,
        currencyCode,
        locale
      ),
    };

    return this._translateService.instant(
      'PAYMENTS.BANK_TRANSFER.DESCRIPTION',
      translateParams
    );
  }

  buildPaypalLogos(companyCountry: string): List<string> {
    const logos = List(['paypal']);

    if (companyCountry === 'US') {
      return logos.push('venmo');
    }

    return logos;
  }
}
